import { Tabs } from 'antd'
import { useState } from 'react'
import ProcurementContent from './components/ProcurementContent'
import './index.less'
import { ProcurementType } from './hooks/useProcurementTypeContext'
import { procurementTypeEnum, purchaseTypeMap } from './config'
export default function Procurement(props) {
  const purchaseOrderNo = props.location.query?.purchaseOrderNo
  const kkey = props.location.query?.activeKey || 1
  const [showAdd, setShowAdd] = useState(false)
  const [activeKey, setActiveKey] = useState(kkey+'')
  return (
    <>
      <div style={showAdd ? { height: 0, width: 0, overflow: 'hidden' } : {}}>
        <Tabs activeKey={activeKey} onChange={setActiveKey}>
          {procurementTypeEnum.map(item => (
            <Tabs.TabPane tab={purchaseTypeMap[item]} key={item}></Tabs.TabPane>
          ))}
        </Tabs>
      </div>
      {activeKey === procurementTypeEnum[0] ? (
        <ProcurementType.Provider key={1} value={{procurementType:procurementTypeEnum[0],purchaseOrderNo:purchaseOrderNo}}>
          <ProcurementContent setShowAdd={setShowAdd} showAdd={showAdd} />
        </ProcurementType.Provider>
      ) : (
        <ProcurementType.Provider key={2} value={{procurementType:procurementTypeEnum[1], purchaseOrderNo:purchaseOrderNo}}>
          {' '}
          <ProcurementContent setShowAdd={setShowAdd} showAdd={showAdd} />
        </ProcurementType.Provider>
      )}
    </>
  )
}
